import formatter from 'services/formatter';

export function share({ url, title, text }, onShareSuccess = () => {}, onShareFail = () => {}) {
  if (typeof window !== 'undefined') {
    if (window.plugins && window.plugins.socialsharing) {
      const options = {
        message: text,
        subject: title,
        url,
      };
      window.plugins.socialsharing.shareWithOptions(options, onShareSuccess, onShareFail);
    } else if (navigator.share) {
      navigator
        .share({
          title,
          url,
          text,
        })
        .then(() => {})
        .catch(error => {
          console.info('Could not share this content', error.message);
        });
    }
  }
}

export function canShare() {
  return navigator && navigator.share;
}

export const getSharingText = (title, book, authors) =>
  `${title} from ${book.title} by ${formatter.authorsList.toString(authors)}`;

export default {
  share,
};
